import { useCallback, useContext, useRef } from 'react';

import type { ToastOptions } from './types';

import { ToastContext } from './context';

export const useToast = () => {
  const context = useContext(ToastContext);

  if (!context) {
    throw new Error('useToast must be used within ToastProvider.');
  }

  const { dismiss, enqueue, toasts } = context;
  const enqueueRef = useRef(enqueue);
  enqueueRef.current = enqueue;

  const toast = useCallback(
    (options: ToastOptions) => enqueueRef.current(options),
    [],
  );

  const isActive = useCallback(
    (id: string | number) => toasts.some((item) => item.id === String(id)),
    [toasts],
  );

  return {
    dismiss,
    isActive,
    toast,
  };
};
